//Template config options
const themeConfig = {
  app: {
    appName: require("@src/assets/images/logo/BieniMedicoLogoLarge.svg").default,
    appLogoImage: require("@src/assets/images/logo/logo2.svg").default,
    appLogoCollapsed: require("@src/assets/images/logo/BieniMedicoLogo.svg").default,
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: false, // Scroll-to-top is handled by the app scroll root.
    toastPosition: "top-right",
  },
};

export default themeConfig;
